import { LayoutList, Mail, Phone } from 'lucide-react';
import { telHref, type CompanySummary } from '@nesc/shared';
import { cn } from '@/lib/utils';

/** 連絡先の有無。無い種別は淡色で表示する（企業一覧・リスト詳細で共用） */
export const ContactIcons = ({
  company,
  showLabels,
}: {
  company: Pick<CompanySummary, 'hasEmail' | 'hasForm' | 'hasPhone' | 'primaryPhone'>;
  showLabels?: boolean;
}) => {
  const items = [
    { has: company.hasEmail, icon: Mail, label: 'メール' },
    { has: company.hasForm, icon: LayoutList, label: 'フォーム' },
    { has: company.hasPhone, icon: Phone, label: '電話' },
  ];

  return (
    <span className="flex items-center gap-3">
      {items.map((item) => (
        <span
          key={item.label}
          className={cn(
            'inline-flex items-center gap-1 text-note',
            item.has ? 'text-foreground' : 'text-foreground-subtle opacity-40',
          )}
          title={item.has ? `${item.label}あり` : `${item.label}なし`}
        >
          <item.icon aria-hidden className="size-4" />
          {showLabels && <span>{item.label}</span>}
        </span>
      ))}
      {company.primaryPhone && showLabels && (
        <a
          href={telHref(company.primaryPhone)}
          onClick={(e) => e.stopPropagation()}
          className="ml-auto inline-flex min-h-touch items-center gap-1 rounded-control px-2 text-note text-foreground underline underline-offset-2 lg:hidden"
        >
          <Phone aria-hidden className="size-4" />
          発信
        </a>
      )}
    </span>
  );
};
